import { faArrowRight, faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from '@lingui/react/macro';
import { Button } from '@repo/videa-components/src';
import { Link } from 'react-router-dom';

import type { Appointment } from '../../../../react-query/useAppointments';

interface ReviewFindingsButtonProps {
  onReviewRadiographs?: () => void;
  appointment: Appointment;
  annotatorUri?: string;
}

export const ReviewFindingsButton = ({
  onReviewRadiographs,
  appointment,
  annotatorUri,
}: ReviewFindingsButtonProps) => {
  const isReviewed = appointment.viewed;

  return (
    <Link
      to={annotatorUri}
      onClick={() => {
        onReviewRadiographs?.();
      }}
      className="findings-review"
    >
      <Button
        className="vai-cursor-pointer"
        variant={isReviewed ? 'completed' : 'default'}
        
        data-testid="review-button"
        name="Review"
      >
        <span className="vai-hidden xl:vai-inline">
          {isReviewed ? <Trans>Reviewed</Trans> : <Trans>Review</Trans>}
        </span>
        <FontAwesomeIcon icon={isReviewed ? faCheck : faArrowRight} />
      </Button>
    </Link>
  );
};
